import { createTranslocoScope } from '@gde-mit/angular-core';

/** Lazy-loaded Transloco scope for the projects domain. */
export const PROJECTS_TRANSLOCO = createTranslocoScope('PROJECTS', (lang) => import(`./i18n/${lang}.json`));

/** Transloco key prefix for projects-domain copy (`PROJECTS.*`). */
export const PROJECTS_I18N_PREFIX = 'PROJECTS';
